import { render, staticRenderFns } from "./ErrorDetail.vue?vue&type=template&id=722935b8"
import script from "./ErrorDetail.vue?vue&type=script&lang=js"
export * from "./ErrorDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports